import { showWpsLoginAsync } from './wps-fn';

/**
 * 根据环境登陆
 */
export function showLoginHandler() {
  showWpsLoginAsync();
}
